export const MAX_STEPS = 32;
export const MAX_LUTS = 12;
